import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import UserRole, { getHighestRole } from "../../model/user-role";
import { RootState } from "../store";
import { ADMIN_ACCESS } from '../../components/commons/AccesRoles';

export interface UserState {
  id?: string;
  name?: string;
  roles?: UserRole[];
  assumedRole?: UserRole;
}

const initialState: UserState = {};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserState>) => {
      state.id = action.payload.id;
      state.name = action.payload.name;
      state.roles = action.payload.roles;
      state.assumedRole = getHighestRole(action.payload.roles || []);
    },
    setAssumedRole: (state, action: PayloadAction<UserRole>) => {
      state.assumedRole = action.payload;
    },
  },
});

// export actions
export const { setUser, setAssumedRole } = userSlice.actions;

// export selectors
export const selectUser = (state: RootState) => state.user;
export const selectAssumedRole = (state: RootState) => state.user.assumedRole;
export const selectCanDeleteCamera = (state: RootState) => (ADMIN_ACCESS.includes(state.user.assumedRole || ''));

// export reducers
export default userSlice.reducer;
